import { format, isToday } from 'date-fns'
import { forwardRef } from 'react'
import { parseDateString } from '../../utils/dateUtils'

const TimelineDivider = forwardRef(function TimelineDivider({ date }, ref) {
  const dateObj = typeof date === 'string' ? parseDateString(date) : date
  const showToday = isToday(dateObj)

  // Format: "1 January 2026" (day name month year)
  const formattedDate = format(dateObj, 'd MMMM yyyy')
  const displayText = showToday ? `TODAY · ${formattedDate}` : formattedDate

  return (
    <div ref={ref} className="relative flex items-center justify-center py-4">
      {/* Left red line */}
      <div className="flex-1 h-[2px] bg-red-500" />

      {/* Pill-shaped date container */}
      <div className="px-5 py-1.5 bg-red-500 rounded-full">
        <span className="text-sm font-semibold text-white whitespace-nowrap">
          {displayText}
        </span>
      </div>

      {/* Right red line */}
      <div className="flex-1 h-[2px] bg-red-500" />
    </div>
  )
})

export default TimelineDivider
